// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: DZ9wrcPtiDwQ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicMilestoneFooter.module.css"; // plasmic-import: DZ9wrcPtiDwQ/css

createPlasmicElementProxy;

export const PlasmicMilestoneFooter__VariantProps = new Array();

export const PlasmicMilestoneFooter__ArgProps = new Array();

const $$ = {};

function PlasmicMilestoneFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"submitButton"}
        data-plasmic-override={overrides.submitButton}
        className={classNames(projectcss.all, sty.submitButton)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          {"Submit"}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "submitButton", "text"],
  submitButton: ["submitButton", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMilestoneFooter__ArgProps,
          internalVariantPropNames: PlasmicMilestoneFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMilestoneFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMilestoneFooter";
  } else {
    func.displayName = `PlasmicMilestoneFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicMilestoneFooter = Object.assign(
  // Top-level PlasmicMilestoneFooter renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    submitButton: makeNodeComponent("submitButton"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicMilestoneFooter
    internalVariantProps: PlasmicMilestoneFooter__VariantProps,
    internalArgProps: PlasmicMilestoneFooter__ArgProps
  }
);

export default PlasmicMilestoneFooter;
/* prettier-ignore-end */
